export default "__VITE_ASSET__ByrQ7vKX__"